// src/theme/index.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2563eb", // blue-600
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#111111",
    },
    background: {
      default: "#f6f7f8", // light background like inspiration
      paper: "#ffffff",
    },
    text: {
      primary: "#111111",
      secondary: "rgba(0,0,0,0.65)",
    },
    divider: "rgba(0,0,0,0.10)",
  },

  typography: {
    // Body
    fontFamily:
      '"Raleway", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 16,

    // Headings
    h1: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h5: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h6: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },

    button: {
      textTransform: "none",
      fontWeight: 700,
      letterSpacing: 0.2,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  },

  shape: {
    borderRadius: 8,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitTapHighlightColor: "transparent",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid rgba(0,0,0,0.10)",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 9999,
        },
      },
    },
  },
});

export default theme;